import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeCandidateInitialState, changeAdvanceSearchInitialState } from "../../../store/candidate/candidateSlice";

const mapStateToProps = (state) => {
    return {
        formType: state.candidate.formType,
        initialValues: state.candidate.initialValues,
        showDrawer: state.candidate.showDrawer,
        advanceSearchInitialVal: state.candidate.advanceSearchInitialVal,
    };
};

const mapDispatch = {
    changeCandidateInitialState,
    changeAdvanceSearchInitialState,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;